// eslint-disable-next-line @tseslint/typedef
export const HEADER_DISPLAY_TYPES = {
  string: "string",
  icon: "icon"
} as const;
export type HeaderDisplayType = typeof HEADER_DISPLAY_TYPES[keyof typeof HEADER_DISPLAY_TYPES];
